export default {
  // eFight: ['41', '42', '43', '44', '45', '46', '47', '49'],
  // isEFight(e) {
  //   if (e) return this.eFight.includes(e.toString()); else return false;
  // },
  isTodayOnly: true,
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  whiteLabel: process.env.VUE_APP_WHITE_LABEL,
  widgetUrl: process.env.VUE_APP_WIDGET_URL || "https://new.wbetwidget.com",
  baseUrl: process.env.VUE_APP_BASE_URL,
  rulesUrl: process.env.VUE_APP_RULES_URL,
  rulesUrl: process.env.VUE_APP_TERMS_URL,
  cacheUrl: process.env.VUE_APP_CACHE_URL,
  esports2: process.env.VUE_APP_ESP_SUPPORT,

  // mobile version sub domain
  uiV1SubUrl: process.env.VUE_APP_UIV1_SUB_URL,
  uiV2SubUrl: process.env.VUE_APP_UIV2_SUB_URL,  

  // Third-party games API
  live22Url: process.env.VUE_APP_LIVE22_URL,
  extUrl: process.env.VUE_APP_EXT2_URL,
  gpUrl: process.env.VUE_APP_EXT_URL,
  saUrl: process.env.VUE_APP_SA_URL,
  ctUrl: process.env.VUE_APP_CT_URL,
  pgUrl: process.env.VUE_APP_PG_URL,
  vivoUrl: process.env.VUE_APP_VIVO_URL,
  evoUrl: process.env.VUE_APP_EVO_URL,
  magUrl: process.env.VUE_APP_MAG_URL,
  ybUrl: process.env.VUE_APP_YB_URL,
  pgsUrl: process.env.VUE_APP_PGS_URL,
  ppgUrl: process.env.VUE_APP_PPG_URL,
  ppgGameImgUrl: process.env.VUE_APP_PPG_GAMEIMG_URL,
  espUrl: process.env.VUE_APP_ESP_URL,
  jkrUrl: process.env.VUE_APP_JKR_URL,
  sppUrl: process.env.VUE_APP_SPP_URL,
  jiliUrl: process.env.VUE_APP_JILI_URL,
  lcppgUrl: process.env.VUE_APP_LCPPG_URL,
  jiliGameImgUrl: process.env.VUE_APP_RESOURCE + '/img/slots/jili/ID_',
  resourceImgUrl: process.env.VUE_APP_RESOURCE,
  uuslUrl: process.env.VUE_APP_UUSL_URL,
  nextUrl: process.env.VUE_APP_NEXT_URL,
  dbhashUrl: process.env.VUE_APP_DBHASH_URL,
  dbpokerUrl: process.env.VUE_APP_DBPOKER_URL,
  wowgamingUrl: process.env.VUE_APP_WOWGAMING_URL,
  aicasinoUrl: process.env.VUE_APP_AICASINO_URL,
  wfUrl: process.env.VUE_APP_WF_URL,
  epwUrl: process.env.VUE_APP_EPW_URL,
  awcUrl: process.env.VUE_APP_AWC_URL,
  aioUrl: process.env.VUE_APP_AIO_URL,
  onliveUrl: process.env.VUE_APP_ONLIVE_URL,
  mtcasinoUrl: process.env.VUE_APP_MTCASINO_URL,
  foxyUrl: process.env.VUE_APP_FOXY_URL,

  // Third-party result API
  r1Url: process.env.VUE_APP_R1_URL,
  r2Url: process.env.VUE_APP_R2_URL,
  r3Url: process.env.VUE_APP_R3_URL,

  // Live stream API
  liveUrl: process.env.VUE_APP_LIVE_URL,

  // 4D games API
  w4dUrl: process.env.VUE_APP_W4D_URL,
  ipify1: process.env.VUE_APP_IPIFY1,
  ipify2: process.env.VUE_APP_IPIFY2,

  w4dSupport: process.env.VUE_APP_W4D_SUPPORT,
  mmoSupport: process.env.VUE_APP_MMO_SUPPORT == "1",
  sportsradar: process.env.VUE_APP_SPORTSRADAR == "1",
  newFeatures: process.env.VUE_APP_NEW_FEATURES == "1",
  logoPath: process.env.VUE_APP_LOGO,
  cnyMode: process.env.VUE_APP_CNY == "1",
  logoCNYPath: process.env.VUE_APP_LOGO_CNY,
  xmasMode: process.env.VUE_APP_XMAS == "1",
  logoXMASPath: process.env.VUE_APP_LOGO_XMAS,
  wcMode: process.env.VUE_APP_WC == "1",
  logoWCPath: process.env.VUE_APP_LOGO_WC,
  contact: process.env.VUE_APP_CONTACT == "1",
  brand: process.env.VUE_APP_BRAND,
  landingPath: process.env.VUE_APP_LANDING,

  arcadePath: process.env.VUE_APP_AR_DETAIL_URL,
  arcadeCert: process.env.VUE_APP_AR_DETAIL_CERT,

  pgsPath: process.env.VUE_APP_PGS_DETAIL_URL,
  ppgPath: process.env.VUE_APP_PPG_DETAIL_URL,
  jkrPath: process.env.VUE_APP_JKR_DETAIL_URL,
  sppPath: process.env.VUE_APP_SPP_DETAIL_URL,
  jiliPath: process.env.VUE_APP_JILI_DETAIL_URL,
  lcppgPath: process.env.VUE_APP_LCPPG_DETAIL_URL,
  uuslPath: process.env.VUE_APP_UUSL_DETAIL_URL,
  nextPath: process.env.VUE_APP_NEXT_DETAIL_URL,
  dbhashPath: process.env.VUE_APP_DBHASH_DETAIL_URL,
  wowgamingPath: process.env.VUE_APP_WOWGAMING_DETAIL_URL,
  aicasinoPath: process.env.VUE_APP_AICASINO_DETAIL_URL,
  live22Path: process.env.VUE_APP_LIVE22_DETAIL_URL,
  wfPath: process.env.VUE_APP_WF_DETAIL_URL,
  epwPath: process.env.VUE_APP_EPW_DETAIL_URL,
  awcPath: process.env.VUE_APP_AWC_DETAIL_URL,
  aioPath: process.env.VUE_APP_AIO_DETAIL_URL,
  onlivePath: process.env.VUE_APP_ONLIVE_DETAIL_URL,
  mtcasinoPath: process.env.VUE_APP_MTCASINO_DETAIL_URL,
  foxyPath: process.env.VUE_APP_FOXY_DETAIL_URL,

  // THB match-time display is opt-in per build; unset/0 preserves GMT+8.
  thbGmt7: process.env.VUE_APP_THB_GMT7 == "1",

  youtubeLink: "https://youtu.be/eOsdB7HHADc",
  kofLink: "https://www.youtube.com/watch?v=4xV_ZQ7CkGY", //https://www.youtube.com/watch?v=9me2jhPsEN4
  cnyLink: "https://www.youtube.com/watch?v=jYbq-djF8vI",
  basePath: "",
  cachePath: "",
  extPath: "/osg",
  betPath: "/bet",
  tournamentPath: "/tournament",
  flagPath: "https://logo.myw0011001.com/",
  tournamentBackgroundPath: "https://r.myw0011001.com/img/tournament/",
  debugMode: process.env.VUE_APP_DEBUG == "true",
  defaultInterval: 1000,
  initialInterval: 1000,
  defaultLang: process.env.VUE_APP_LANG,
  defaultOdds: process.env.VUE_APP_ODDS,
  showInterval: 50,
  parlayMaxTicket: 12,    // 12
  parlayMinTicket: 2,     // 2
  parlayLiveMinTicket: 3, // 3
  mmoParlayMinTicket: 2,
  timeZone: { timeZone: "Asia/Kuala_Lumpur" },
  // moreBetTypes: "tw|cs|dc|fglg|htft|tg|orz|anb|bs|cl|dnb|hnb|twtn|ml|oehm|oeaw",
  moreBetTypes: "tw|cs|dc|fglg|htft|tg|orz|anb|bs|cl|dnb|hnb|twtn|ml|oehm|oeaw|oxtou|dcou|ouoe|etg|ehtg|eatg|wm|htftoe|cshtft|etghtft",
  oddsTypeLocale: {
    1: "ui.my_odds",
    2: "ui.hk_odds",
    3: "ui.id_odds",
    4: "ui.dec_odds",
    5: "ui.mmo_odds"
  },
  oddsTypeName: {
    1: "MY",
    2: "HK",
    3: "ID",
    4: "DEC"
  },
  oddsTypeId: {
    MY: 1,
    HK: 2,
    ID: 3,
    DEC: 4
  },
  matchStatusName: {
    0: "ui.match_pending",
    1: "ui.match_completed",
    2: "ui.match_cancelled",
    5: "ui.match_suspended",
    500: "ui.inactive"
  },
  matchStatusId: {
    Live: 0,
    Completed: 1,
    Cancelled: 2,
    Suspended: 5
  },
  marking: ["HDP", "HDPH", "OU", "OUH", "OE", "OEH", "OEAW", "OEAWH", "OEHM", "OEHMH"],
  markets: ["close", "early", "today", "live", "parlay"],
  // defaultSportOrder: [1, 40, 2, 7, 3, 5, 12, 4, 11, 8, 30, 9, 13, 6, 19, 35, 14, 15, 24, 34, 25, 23, 17, 31, 16, 27, 10, 18, 26, 36, 37, 32, 21, 28, 38, 29, 20, 22, 39, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 54, 56],
  // defaultSportOrder1: [12, 1, 40, 2, 7, 3, 5, 4, 11, 8, 30, 9, 13, 6, 19, 35, 14, 15, 24, 34, 25, 23, 17, 31, 16, 27, 10, 18, 26, 36, 37, 32, 21, 28, 38, 29, 20, 22, 39, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 54, 56],
  // defaultSportExclude: [22, 24, 33, 39, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 54, 56],
  defaultSportOrder: [1, 40, 2, 7, 3, 5, 12, 4, 11, 8, 30, 9, 13, 6, 19, 35, 14, 15, 24, 34, 25, 23, 17, 31, 16, 27, 10, 18, 26, 36, 37, 32, 21, 28, 38, 29, 20, 22, 39, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 54, 55, 56,57],
  defaultSportOrder1: [12, 1, 40, 2, 7, 3, 5, 4, 11, 8, 30, 9, 13, 6, 19, 35, 14, 15, 24, 34, 25, 23, 17, 31, 16, 27, 10, 18, 26, 36, 37, 32, 21, 28, 38, 29, 20, 22, 39, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 54, 55, 56,57],
  defaultSportExclude: [22, 24, 33, 39, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 54, 55, 56,57],
  forecastFtBettype: ["HDP", "OU", "OE", "1X2", "ML", "1X2HDP", "CS", "DC", "TG", "ANB", "DNB", "HNB", "BS", "CL", "TWTN"],
  quickBetValue20: {
    MYR: 20,
    CNY: 40,
    HKD: 40,
    IDR: 66,
    THB: 200,
    USD: 5,
    VND: 100
  },
  quickBetValue100: {
    MYR: 100,
    CNY: 200,
    HKD: 200,
    IDR: 333,
    THB: 1000,
    USD: 25,
    VND: 500
  },
  quickBetValue500: {
    MYR: 500,
    CNY: 1000,
    HKD: 1000,
    IDR: 1666,
    THB: 5000,
    USD: 125,
    VND: 2500
  },
  languageAvailable: [
    { lang: "English", id: "en" },
    { lang: "简体中文", id: "cn" },
    { lang: "繁體中文", id: "tw" },
    { lang: "Melayu", id: "my" },
    { lang: "Indonesia", id: "id" },
    { lang: "日本語", id: "jp" },
    { lang: "한국어", id: "kr" },
    { lang: "ไทย", id: "th" },
    { lang: "Tiếng Việt", id: "vi" }
  ],
  esportsTab: {
    101: "Map 1",
    102: "Map 2",
    103: "Map 3",
    104: "Map 4",
    105: "Map 5",
    106: "Map 6",
    107: "Map 7",
    108: "Map 8",
    109: "Map 9",
    110: "Map 10"
  },
  sports4dTab: {
    101: "1ST PRIZE",
    102: "2ND PRIZE",
    103: "3RD PRIZE"
  },
  sportsSFVTab: {
    101: "ROUND 1",
    102: "ROUND 2",
    103: "ROUND 3",
    104: "ROUND 4",
    105: "ROUND 5"
  },
  CSHTFTX: ["0-0", "0-1", "0-2", "0-3", "0-4", "1-0", "1-1", "1-2", "1-3", "1-4", "2-0", "2-1", "2-2", "2-3", "2-4", "3-0", "3-1", "3-2", "3-3", "3-4", "4-0", "4-1", "4-2", "4-3", "4-4", "AOS"],
  ETGHTFTX: ["0", "1", "2", "3", "4", "5", "6", "7", "7+", "8", "8+", "9", "9+", "10+"],
  matchPerPage: 100,
  useConfigUrl: process.env.VUE_APP_STATIC_URL == "true",
  // gamesList: ["57","56", "55", "53", "50", "52", "49", "51", "43", "41", "44", "42", "45", "46", "47"],
  // day1: [1, 20, 40, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 54, 55, 56, 57],
  // special: [40, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 54, 55, 56, 57],
  // vg1: [41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 54, 55, 56, 57],
  gamesList: ["57", "56", "55", "53", "50", "52", "49", "51", "43", "41", "44", "42", "45", "46", "47"],
  day1: [1, 20, 40, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 55, 56, 57],
  // Days of week (0 = Sunday ... 6 = Saturday) where the "Today" tab opens on the upcoming-hours filter instead of "All"
  todayUpcomingDays: [0, 6],
  // Hour range preselected on those days, must match one of the hour tabs ("1" | "3" | "6")
  todayUpcomingHours: "3",
  // Today "All" paints the next N hours first, then merges the full list in place (set false to load the full list in one go)
  todayProgressive: true,
  todayProgressiveHours: "3",
  // Sports that use the two-step load. Everything else asks for the full Today list in one request,
  // since only soccer is large enough for the window to be worth an extra call.
  todayProgressiveSports: [1],
  applyWeekendTodayMarket(mi5, dayIndex, store) {
    if (!mi5 || !store) {
      return mi5;
    }
    if (mi5.menu0 != "all" || mi5.menu1 != "today" || mi5.menu3 != "hdpou") {
      return mi5;
    }
    if (this.gamesList.includes(String(mi5.menu2))) {
      return mi5;
    }
    if (!this.todayUpcomingDays.includes(dayIndex)) {
      return mi5;
    }
    store.dispatch("layout/setUpcomingHours", this.todayUpcomingHours);
    var upcomingLive = {};
    upcomingLive[parseInt(mi5.menu2)] = true;
    store.dispatch("layout/setOptions", { property: "live", value: upcomingLive });
    mi5.menu0 = "upcoming";
    mi5.menu1 = "upcoming";
    return mi5;
  },
  special: [40, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 55, 56, 57],
  vg1: [41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 55, 56, 57],
  efightList: [
    41, // SF4
    42, // UFC3
    43, // KOF
    44, // MK
    47, // TEKKEN 8
    52, // DRAGON BALL
    53, // NARUTO
  ],
  racingList: [
    45, // Greyhound
    46, // Motor
    49, // Marble Run
    50, // Marble Clash
    51, // Marble Survival
    54, // Marble Rafting
    55, // Mario Party Superstars
    56, // Cockfight
    57, // Bomberman
  ],
  racingList1: [
    45, // Greyhound
    46, // Motor
    49, // Marble Run
  ],
  racingList2: [50], // Marble Survival game like result
  racingList3: [51], // Marble Clash game like result
  racingList4: [54], // Marble Rafting game like result
  racingList5: [55], // Mario Party Superstars game like result
  racingList6: [56], // Cockfight game like result
  racingList7: [57], // Bomberman game like result
  params: {
    57: {
      delay: 4,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/bomberman-thumb.jpg",
    },
    56: {
      delay: 4,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/cockfight-thumb.png",
    },
    55: {
      delay: 3,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/mario-thumb.jpg",
    },
    54: {
      delay: 2,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/marble-rafting-thumb.jpg",
    },
    53: {
      delay: 1,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/naruto-thumb.jpg",
    },
    52: {
      delay: 0,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/dragonball-thumb.jpg",
    },
    51: {
      delay: 4,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/marble-survival-thumb.jpg",
    },
    50: {
      delay: 1,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/marble-clash-thumb.jpg",
    },
    49: {
      delay: 0,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/marble-thumb.jpg",
    },
    47: {
      delay: 2,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/tk8-thumb.jpg",
    },
    46: {
      delay: 3,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/speedway-thumb.jpg",
    },
    45: {
      delay: 2,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/greyhound-thumb.jpg",
    },
    44: {
      delay: 4,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/mk-thumb.jpg",
    },
    43: {
      delay: 0,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/kof-thumb.jpg",
    },
    42: {
      delay: 1,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/ufc-thumb.jpg",
    },
    41: {
      delay: 3,
      duration: 5,
      live: 1,
      thumbnail: "images/egame/game-thumb/sf6-thumb.jpg",
    },
  },
  // 41: SF4
  // 42: UFC3
  // 43: KOF
  // 44: MK
  // 45: GREYHOUND
  // 46: MOTOR
  // 47: TEKKEN 8
  // 49: MARBLE RUN
  // 50: MARBLE CLASH
  // 51: MARBLE SURVIVAL
  // 52: DRAGON BALL
  // 53: NARUTO
  // 54: MARBLE RAFTING
  // 55: MARIO PARTY SUPERSTARS
  // 56: COCKFIGHT
  // 57: BOMBERMAN
  // 58: NOT IN USED
  gameStream: {
    41: "vDYS8-n3Zn1", // SF4
    42: "vDYS8-t1rfZ", // UFC3
    43: "vDYS8-N7FsO", // KOF
    44: "vDYS8-vbyfY", // MK
    45: "vDYS8-UgMqO", // GREYHOUND
    46: "vDYS8-AXaJR", // MOTOR
    47: "vDYS8-wZpoI", // TEKKEN 8
    49: "vDYS8-lTgN2", // MARBLE RUN
    50: "vDYS8-ixFkb", // MARBLE CLASH
    51: "vDYS8-eemJ4", // MARBLE SURVIVAL
    52: "vDYS8-0tGgf", // DRAGON BALL
    53: "vDYS8-v2kwn", // NARUTO
    54: "vDYS8-3Mnd3", // MARBLE RAFTING
    55: "vDYS8-MeVYp", // MARIO PARTY SUPERSTARS
    56: "vDYS8-WNR25", // COCKFIGHT
    57: "vDYS8-UYGnM", // BOMBERMAN

    141: "vDYS8-n3Zn1", // SF4
    142: "vDYS8-t1rfZ", // UFC3
    143: "vDYS8-N7FsO", // KOF
    144: "vDYS8-vbyfY", // MK
    145: "vDYS8-UgMqO", // GREYHOUND
    146: "vDYS8-AXaJR", // MOTOR
    147: "vDYS8-wZpoI", // TEKKEN 8
    149: "vDYS8-lTgN2", // MARBLE RUN
    150: "vDYS8-ixFkb", // MARBLE CLASH
    151: "vDYS8-eemJ4", // MARBLE SURVIVAL
    152: "vDYS8-0tGgf", // DRAGON BALL
    153: "vDYS8-v2kwn", // NARUTO
    154: "vDYS8-3Mnd3", // MARBLE RAFTING
    155: "vDYS8-MeVYp", // MARIO PARTY SUPERSTARS
    156: "vDYS8-WNR25", // COCKFIGHT
    157: "vDYS8-UYGnM", // NOT IN USED
  },
  // Return currency-specific minute offset for displaying match times
  // Example: MMK/MMO = 90 minutes, NGN = 420 minutes, others = 0
  getCurrencyMinuteOffset(currencyCode) {
    switch (currencyCode) {
      case "MMK":
      case "MMO":
        return 90;
      case "NGN":
        return 420;
      case "VND":
        return 60;
      case "THB":
        return this.thbGmt7 ? 60 : 0;
      default:
        return 0;
    }
  },
  leagueKindColors: process.env.VUE_APP_LEAGUE_KIND_COLORS != "0",
  getLandingUrl(fn) {
    return "https://r.myw0011001.com/images/" + this.landingPath + "/" + fn + "?v=2";
  },
  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");

    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }

    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },
  getBaseUrl() {
    if (this.useConfigUrl) {
      return this.baseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      return "https://app." + domain;
    } else {
      return this.baseUrl;
    }
  },
  getCacheUrl() {
    if (this.useConfigUrl) {
      return this.cacheUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      return "https://odds." + domain;
    } else {
      return this.cacheUrl;
    }
  },
  getEuroPageUrl() {
    var domain = this.getDomain(window.location.hostname, false);
    // console.log(domain);
    return "https://wbeteuro.com?referer=m." + domain;
    // return "https://wbetwc.com?referer=m." + domain;
  },
  getSportsImage(e) {
    var result = e + ".svg?v=12";
    switch (e) {
      case 41:
      case "41":
      // case 47:
      // case "47":
        result = e + ".png?v=12";
        break;
    }

    return result;
  },
  radarUrl() {
    // Sportsradar
    return this.liveUrl + "/sportsradar?m=";
  },
  bintuUrl() {
    // Sportsradar
    return this.liveUrl + "/bintu?v=";
  },
  player10Url() {
    return this.liveUrl + "/player10?v=";
  },
  statscenterUrl() {
    // Sportsradar
    return this.liveUrl + "/football?m=";
  //   if(this.sportsradar) {
  //     return this.liveUrl + "/statscenter?m=";
  //   } else {
  //     return this.liveUrl + "/football?m=";
  //   }
  },
  r3ResultUrl() {
    // Live22
    return this.r3Url + "/result?bet_id=";
  },
  r2ResultUrl() {
    // GamingSoft
    return this.r2Url + "/result?bet_id=";
  },
  r1ResultUrl() {
    // All casino
    return this.r1Url + "/result?";
  },
  ngResultUrl() {
    return this.getBaseUrl() + this.basePath + "/ngresult";
  },
  efResultUrl() {
    return this.getBaseUrl() + this.basePath + "/efresult";
  },
  prgUrl() {
    return this.getBaseUrl() + this.basePath + "/prg";
  },
  apiTvUrl() {
    return this.getBaseUrl() + this.basePath + "/apitv";
  },
  liveTvUrl() {
    return this.getBaseUrl() + this.basePath + "/livetv2";
  },
  liveTvListUrl() {
    return this.getBaseUrl() + this.basePath + "/livetvlistmobile";
  },
  liveMatchListUrl() {
    return this.getBaseUrl() + this.basePath + "/livematchlist";
  },
  highlightLeagueUrl() {
    return this.getBaseUrl() + this.basePath + "/highlightleague";
  },
  highlightListUrl() {
    return this.getBaseUrl() + this.basePath + "/highlightlist";
  },
  eventListUrl() {
    return this.getBaseUrl() + this.basePath + "/eventlist";
  },
  standingListUrl() {
    return this.getBaseUrl() + this.basePath + "/standinglist";
  },
  standingResultUrl() {
    return this.getBaseUrl() + this.basePath + "/standingresult";
  },
  bracketListUrl() {
    return this.getBaseUrl() + this.basePath + "/bracketlist";
  },
  versionUrl() {
    return this.getBaseUrl() + this.basePath + "/version";
  },
  authLoginUrl() {
    return this.getBaseUrl() + this.basePath + "/authlogin";
  },
  switchLoginUrl() {
    return this.getBaseUrl() + this.basePath + "/switchlogin";
  },
  switchLoginApiUrl() {
    return this.getBaseUrl() + this.basePath + "/switchloginapi";
  },
  loginUrl() {
    return this.getBaseUrl() + this.basePath + "/mobilelogin";
  },
  getBalanceUrl() {
    return this.getBaseUrl() + this.basePath + "/userbalance";
  },
  getVBalanceUrl() {
    return this.getBaseUrl() + this.basePath + "/vuserbalance";
  },
  getProfileUrl() {
    return this.getBaseUrl() + this.basePath + "/userprofile";
  },
  getMenuUrl() {
    return this.getCacheUrl() + this.cachePath + "/uxmenu";
  },
  getTimeMachineUrl() {
    return this.getBaseUrl()  + this.betPath + "/bettimemachineminutes";
  },
  getTimeMachineBetUrl() {
    return this.getBaseUrl()  + this.betPath + "/bettimemachinecheck";
  },
  getTimeMachinePlaceBetUrl() {
    return this.getBaseUrl()  + this.betPath + "/bettimemachine";
  },
  getVTimeMachinePlaceBetUrl() {
    return this.getBaseUrl()  + this.betPath + "/vbettimemachine";
  },
  getMarketUrl() {
    return this.getCacheUrl() + this.cachePath + "/uxmarket";
  },
  getMatchUrl() {
    return this.getCacheUrl() + this.cachePath + "/uxmatch";
  },
  getMatch2Url() {
    return this.getCacheUrl() + this.cachePath + "/uxmatch2";
  },
  changePasswordUrl() {
    return this.getBaseUrl() + this.basePath + "/changepassword";
  },
  addSecondaryUrl() {
    return this.getBaseUrl() + this.basePath + "/addsecondary";
  },
  setSettingsUrl() {
    return this.getBaseUrl() + this.basePath + "/usersettings";
  },
  dailyStatementUrl() {
    return this.getBaseUrl() + this.basePath + "/dailystatement";
  },
  platformWinloseUrl() {
    return this.getBaseUrl() + this.basePath + "/platformwinlose";
  },
  settlementUrl() {
    return this.getBaseUrl() + this.basePath + "/settlementhistory";
  },
  gameResultSportsbookUrl() {
    return this.getBaseUrl() + this.basePath + "/gameresultsportsbook";
  },
  gameResultSlotsUrl() {
    return this.getBaseUrl() + this.basePath + "/gameresultslots";
  },
  gameResultLiveCasinoUrl() {
    return this.getBaseUrl() + this.basePath + "/gameresultlivecasino";
  },
  gameResultLotteryUrl() {
    return this.getBaseUrl() + this.basePath + "/gameresultlottery";
  },
  gameResultEsports2Url() {
    return this.getBaseUrl() + this.basePath + "/gameresultesports2";
  },
  gameResultEsports2DetailUrl() {
    return this.getBaseUrl() + this.basePath + "/gameresultesports2detail";
  },
  gameResultAdjustmentUrl() {
    return this.getBaseUrl() + this.basePath + "/gameresultadjustment";
  },
  cancelledBetListUrl() {
    return this.getBaseUrl() + this.basePath + "/cancelledbetlist";
  },
  cancelledBetListLotteryUrl() {
    return this.getBaseUrl() + this.basePath + "/cancelledbetlistlottery";
  },
  mmoSingleOddCheckUrl() {
    return this.getBaseUrl() + this.betPath + "/betmmoclick";
  },
  mmoSingleUrl() {
    return this.getBaseUrl() + this.betPath + "/betsinglemmo";
  },
  mmoParlayUrl() {
    return this.getBaseUrl() + this.betPath + "/betparlaymmo";
  },
  vMMOSingleUrl() {
    return this.getBaseUrl() + this.betPath + "/vbetsinglemmo";
  },
  vMMOParlayUrl() {
    return this.getBaseUrl() + this.betPath + "/vbetparlaymmo";
  },
  betSingleOddCheckUrl() {
    return this.getBaseUrl() + this.betPath + "/betcheck";
  },
  betSingleOddCheckSpecialUrl() {
    return this.getBaseUrl() + this.betPath + "/betcheckspecial";
  },
  betMultiOddCheckUrl() {
    return this.getBaseUrl() + this.betPath + "/betcheckmultispecial";
  },
  betStatusUrl() {
    return this.getBaseUrl() + this.betPath + "/betstatus";
  },
  betSingleUrl() {
    return this.getBaseUrl() + this.betPath + "/betsingle";
  },
  betSingleSpecialUrl() {
    return this.getBaseUrl() + this.betPath + "/betsinglespecial";
  },
  betParlayUrl() {
    return this.getBaseUrl() + this.betPath + "/betparlay";
  },
  vBetSingleUrl() {
    return this.getBaseUrl() + this.betPath + "/vbetsingle";
  },
  vBetSingleSpecialUrl() {
    return this.getBaseUrl() + this.betPath + "/vbetsinglespecial";
  },
  vBetParlayUrl() {
    return this.getBaseUrl() + this.betPath + "/vbetparlay";
  },
  betSystemParlayUrl() {
    return this.getBaseUrl() + this.betPath + "/betsysparlay";
  },
  vBetSystemParlayUrl() {
    return this.getBaseUrl() + this.betPath + "/vbetsysparlay";
  },
  betAcceptListUrl() {
    return this.getBaseUrl() + this.betPath + "/betacceptlist";
  },
  betRejectListUrl() {
    return this.getBaseUrl() + this.betPath + "/betrejectlist";
  },
  betPendingListUrl() {
    return this.getBaseUrl() + this.betPath + "/pendingbetlist";
  },
  betAcceptListAllUrl() {
    return this.getBaseUrl() + this.betPath + "/betlistaccept";
  },
  betAcceptListAllBetTypeUrl() {
    return this.getBaseUrl() + this.betPath + "/betlistacceptbettype";
  },
  betRejectListAllUrl() {
    return this.getBaseUrl() + this.betPath + "/betrejectfulllist";
  },
  betCashoutCheckUrl() {
    return this.getBaseUrl() + this.betPath + "/cashoutcheck";
  },
  betCashoutUrl() {
    return this.getBaseUrl() + this.betPath + "/cashout";
  },
  dBetAcceptListUrl() {
    return this.getBaseUrl() + this.betPath + "/dbetlist";
  },
  dBetRejectListUrl() {
    return this.getBaseUrl() + this.betPath + "/dbetlistcancel";
  },
  parlayAcceptDetailsUrl() {
    return this.getBaseUrl() + this.betPath + "/parlayacceptbetdetails";
  },
  parlayPendingDetailsUrl() {
    return this.getBaseUrl() + this.betPath + "/parlaypendingbetdetails";
  },
  parlayRejectDetailsUrl() {
    return this.getBaseUrl() + this.betPath + "/parlayrejectbetdetails";
  },
  announceListUrl() {
    return this.getBaseUrl() + this.basePath + "/announcelist";
  },
  marqueeListUrl() {
    return this.getBaseUrl() + this.basePath + "/marqueelist";
  },
  personalListUrl() {
    return this.getBaseUrl() + this.basePath + "/personallist";
  },
  personalUnreadUrl() {
    return this.getBaseUrl() + this.basePath + "/personalunread";
  },
  matchResultUrl() {
    return this.getBaseUrl() + this.basePath + "/matchresult";
  },
  singleMatchResultUrl() {
    return this.getBaseUrl() + this.basePath + "/singlematchresult";
  },
  parlayMatchResultUrl() {
    return this.getBaseUrl() + this.basePath + "/parlaymatchresult";
  },
  statementParlayDetailsUrl() {
    return this.getBaseUrl() + this.basePath + "/parlaybetdetails";
  },
  gameResultSummaryUrl() {
    return this.getBaseUrl() + this.basePath + "/gameresultsummarysportsbook";
  },
  // launchGSUrl() {
  //   return this.extUrl + this.extPath + "/launchslotgame";
  // },
  launchL22Url() {
    return this.extUrl + this.extPath + "/launchslotgame";
  },
  launchLive22Url() {
    return this.live22Url + "/LaunchGame";
  },
  getLive22GameListUrl() {
    return this.live22Url + "/GameList";
  },
  launchGPUrl() {
    return this.gpUrl + this.extPath + "/launchgp";
  },
  launchSAUrl() {
    return this.saUrl + "/LaunchGame";
  },
  launchCTUrl() {
    return this.ctUrl + "/LaunchGame";
  },
  launchPGUrl() {
    return this.pgUrl + "/LaunchGame";
  },
  launchVivoUrl() {
    return this.vivoUrl + "/LaunchGame";
  },
  launchEVUrl() {
    return this.evoUrl + "/LaunchGame";
  },
  launchMagUrl() {
    return this.magUrl + "/LaunchGame";
  },
  launchYBUrl() {
    return this.ybUrl + "/LaunchGame";
  },
  launchLCPPGUrl() {
    return this.lcppgUrl + "/LaunchGame";
  },
  launchW4DUrl() {
    return this.w4dUrl + "/LaunchLottery";
  },
  launchPGSUrl() {
    return this.pgsUrl + "/LaunchGame";
  },
  launchPPGUrl() {
    return this.ppgUrl + "/LaunchGame";
  },
  launchPPGGameListUrl() {
    return this.ppgUrl + "/GameList";
  },
  launchJKRUrl() {
    return this.jkrUrl + "/LaunchGame";
  },
  launchJKRGameListUrl() {
    return this.jkrUrl + "/GameList";
  },
  launchESPUrl() {
    return this.espUrl + "/LaunchGame";
  },
  launchSPPUrl() {
    return this.sppUrl + "/LaunchGame";
  },
  launchJILIUrl() {
    return this.jiliUrl + "/LaunchGame";
  },
  launchJILIGameListUrl() {
    return this.jiliUrl + "/GameList";
  },
  launchUUSLUrl() {
    return this.uuslUrl + "/LaunchGame";
  },
  launchUUSLGameListUrl() {
    return this.uuslUrl + "/GameList";
  },
  launchNEXTUrl() {
    return this.nextUrl + "/LaunchGame";
  },
  launchDbHashUrl() {
    return this.dbhashUrl + "/LaunchGame";
  },
  launchDbPokerUrl() {
    return this.dbpokerUrl + "/LaunchGame";
  },
  launchWowGamingUrl() {
    return this.wowgamingUrl + "/LaunchGame";
  },
  launchAiCasinoUrl() {
    return this.aicasinoUrl + "/LaunchGame";
  },
  launchWfUrl() {
    return this.wfUrl + "/LaunchGame";
  },
  launchWfGameListUrl() {
    return this.wfUrl + "/GameList";
  },
  launchEPWUrl() {
    return this.epwUrl + "/LaunchGame";
  },
  launchEPWGameListUrl() {
    return this.epwUrl + "/GameList";
  },
  launchAwcUrl() {
    return this.awcUrl + "/LaunchGame";
  },
  getAwcGameListUrl() {
    return this.awcUrl + "/GameList";
  },
  launchAioUrl() {
    return this.aioUrl + "/LaunchGame";
  },
  launchOnliveUrl() {
    return this.onliveUrl + "/LaunchGame";
  },
  launchMtCasinoUrl() {
    return this.mtcasinoUrl + "/LaunchGame";
  },
  launchFoxyUrl() {
    return this.foxyUrl + "/LaunchGame";
  },
  reportBetSystemParlayUrl() {
    return this.getBaseUrl() + this.basePath + "/betsysparlay";
  },
  reportBetSystemParlayMatchUrl() {
    return this.getBaseUrl() + this.basePath + "/betsysparlaymatch";
  },
  reportBetSystemParlayBetUrl() {
    return this.getBaseUrl() + this.basePath + "/betsysparlaybet";
  },
  gameResultTournamentUrl() {
    return this.getBaseUrl() + this.basePath + "/gameresulttournament";
  },
  gameResultTournamentRefundUrl() {
    return this.getBaseUrl() + this.basePath + "/gameresulttournamentrefund";
  },
  memberValidateTournamentUrl() {
    return this.getBaseUrl() + this.basePath + "/membervalidatetournament";
  },
  modernClickUrl() {
    return this.getBaseUrl() + this.basePath + "/modernclick";
  },
  tournamentUrl() {
    return {
      roomlist: this.getBaseUrl() + this.tournamentPath + "/roomlist",
      roomleaguelist: this.getBaseUrl() + this.tournamentPath + "/roomleaguelist",
      roommatchlist: this.getBaseUrl() + this.tournamentPath + "/roommatchlist",
      matchlookup: this.getBaseUrl() + this.tournamentPath + "/matchlookup",
      roomcreate: this.getBaseUrl() + this.tournamentPath + "/roomcreate",
      roomjoin: this.getBaseUrl() + this.tournamentPath + "/roomjoin",
      vroomcreate: this.getBaseUrl() + this.tournamentPath + "/vroomcreate",
      vroomjoin: this.getBaseUrl() + this.tournamentPath + "/vroomjoin",
      memberbetlist: this.getBaseUrl() + this.tournamentPath + "/memberbetlist",
      betresultlist: this.getBaseUrl() + this.tournamentPath + "/betresultlist",
      betresultfinal: this.getBaseUrl() + this.tournamentPath + "/betresultfinal",
      bet: this.getBaseUrl() + this.tournamentPath + "/bet",
      betplus: this.getBaseUrl() + this.tournamentPath + "/betplus",
      roomrank: this.getBaseUrl() + this.tournamentPath + "/roomrank",
      roominfo: this.getBaseUrl() + this.tournamentPath + "/roominfo",
    };
  },
};
